import { render } from "./FactorItem.vue?vue&type=template&id=f2a80f6a&scoped=true&ts=true"
import script from "./FactorItem.vue?vue&type=script&lang=ts"
export * from "./FactorItem.vue?vue&type=script&lang=ts"

import "./FactorItem.vue?vue&type=style&index=0&id=f2a80f6a&scoped=true&lang=css"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2a80f6a"]])

export default __exports__